import { OnlineTemplate } from "~/entities/templateEntities";

// Savings colours from the template (cart.offer.savingColour / savingBackground). Older templates don't have them, so
// fall back to the defaults, which meet contrast on white.
const DEFAULT_SAVING_COLOUR = "#055231";
const DEFAULT_SAVING_BACKGROUND = "#daf6e3";

export const offerSavingColour = (template: OnlineTemplate) =>
  template.cart.offer.savingColour || DEFAULT_SAVING_COLOUR;

export const offerSavingBackground = (template: OnlineTemplate) =>
  template.cart.offer.savingBackground || DEFAULT_SAVING_BACKGROUND;

// The template's offer fill, unless it's white or unset (it wouldn't show against the page)
export const offerFill = (template: OnlineTemplate) => {
  const { backgroundColour, fontColour } = template.cart.offer;
  return !backgroundColour || /^#?f{3}(f{3})?$/i.test(backgroundColour)
    ? null
    : { backgroundColor: backgroundColour, color: fontColour };
};
